import { render, staticRenderFns } from "./BillingHandlingInAdditionalIndex.vue?vue&type=template&id=d51df62a&scoped=true&"
import script from "./BillingHandlingInAdditionalIndex.vue?vue&type=script&lang=js&"
export * from "./BillingHandlingInAdditionalIndex.vue?vue&type=script&lang=js&"
import style0 from "./BillingHandlingInAdditionalIndex.vue?vue&type=style&index=0&id=d51df62a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51df62a",
  null
  
)

export default component.exports